import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://xtfpsotbjkawtrwfwnsl.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh0ZnBzb3Riamthd3Ryd2Z3bnNsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcwMTczMjIsImV4cCI6MjA3MjU5MzMyMn0.vTcbZi2Ya0JI-uyqaGTEtibvYvx7WzeMIVPxJ6yU_rQ'

if(SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase